(function () {
  'use strict';

  /* —— Mobile nav —— */
  var toggle = document.getElementById('nav-toggle');
  var nav = document.getElementById('nav-tabs');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      });
    });
  }

  /* —— Optional US state: show only for US, clear + disable otherwise —— */
  function syncStateField(country, selectId, wrapId) {
    var sel = document.getElementById(selectId);
    var wrap = document.getElementById(wrapId);
    var isUS = !!(country && country.value === 'US');
    if (wrap) wrap.hidden = !isUS;
    if (!sel) return '';
    if (!isUS) sel.value = '';
    sel.disabled = !isUS;
    sel.required = false;
    var code = (isUS && sel.value) ? sel.value : '';
    try {
      if (code) sessionStorage.setItem('fwf_state', code);
      else sessionStorage.removeItem('fwf_state');
    } catch (e) {}
    return code;
  }
  window.FWF_syncStateField = syncStateField;

  /* 2026-11-03 fix: keep modal State field in sync on load and on every country change */
  (function () {
    var c = document.getElementById('WaitlistCountryModal');
    if (!c) return;
    syncStateField(c, 'WaitlistStateModal', 'WaitlistStateModalWrap');
    c.addEventListener('change', function () {
      syncStateField(c, 'WaitlistStateModal', 'WaitlistStateModalWrap');
    });
    var s = document.getElementById('WaitlistStateModal');
    if (s) s.addEventListener('change', function () {
      syncStateField(c, 'WaitlistStateModal', 'WaitlistStateModalWrap');
    });
  })();

  /* —— Waitlist meta sync —— */
  function syncWaitlistMeta() {
    var tags = document.getElementById('WaitlistTags');
    var note = document.getElementById('WaitlistNote');
    var country = document.getElementById('WaitlistCountry');
    if (!tags || !note) return;
    var planEl = document.querySelector('input[name="waitlist_plan"]:checked');
    var plan = planEl ? planEl.value : 'unsure';
    var countryVal = country && country.value ? country.value : 'pending';
    var stateCode = syncStateField(country, 'WaitlistState', 'WaitlistStateWrap');
    var tagList = [
      'newsletter',
      'waitlist',
      'plan-' + plan,
      'country-' + countryVal
    ];
    if (stateCode) tagList.push('state-' + stateCode.toLowerCase());
    tags.value = tagList.join(',');
    note.value =
      'Free waitlist | plan=' +
      plan +
      ' | country=' +
      countryVal +
      (stateCode ? ' | state=' + stateCode : '') +
      ' | source=shopify-waitlist';
  }

  var form = document.getElementById('WaitlistForm');
  if (form) {
    form.addEventListener('change', syncWaitlistMeta);
    form.addEventListener('submit', syncWaitlistMeta);
    syncWaitlistMeta();
  }

  /* —— Smooth scroll to in-page anchors (Shopify hash / sticky header fix) —— */
  var HEADER_OFFSET = 88;
  /* 2026-11-03: offset = real sticky header height + 12px; #circle lands on its heading */
  function fwfHeaderOffset() {
    var h = document.querySelector('.site-header');
    if (!h) return 16;
    var r = h.getBoundingClientRect();
    var cs = window.getComputedStyle(h);
    var par = h.parentElement ? h.parentElement.getBoundingClientRect() : null;
    /* sticky only really sticks if its wrapper is taller than the header */
    var stays = cs.position === 'fixed' ||
      (cs.position === 'sticky' && par && par.height > r.height + 4);
    return stays ? r.height + 12 : 16;
  }
  window.FWF_headerOffset = fwfHeaderOffset;
  function fwfAnchorEl(el) {
    return (el && el.querySelector && el.querySelector('[data-anchor-target]')) || el;
  }
  window.FWF_anchorEl = fwfAnchorEl;

  function scrollToId(id, focusEmail) {
    var el = document.getElementById(id);
    if (!el) return false;
    var top = fwfAnchorEl(el).getBoundingClientRect().top + window.pageYOffset - fwfHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    if (history.replaceState) {
      try {
        history.replaceState(null, '', '#' + id);
      } catch (e) { /* ignore */ }
    }
    if (focusEmail && id === 'waitlist') {
      var email = document.getElementById('WaitlistEmail');
      if (email) {
        setTimeout(function () {
          try { email.focus({ preventScroll: true }); } catch (err) { email.focus(); }
        }, 450);
      }
    }
    return true;
  }

  function hashFromHref(href) {
    if (!href) return '';
    var i = href.indexOf('#');
    if (i < 0) return '';
    return href.slice(i + 1).split('?')[0].split('&')[0];
  }

  function onAnchorClick(e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var hash = hashFromHref(a.getAttribute('href'));
    if (!hash) return;
    var known = { waitlist: 1, fairies: 1, about: 1, contact: 1, home: 1, circle: 1 };
    // also how-she-arrives
    if (!known[hash] && hash !== 'how-she-arrives' && hash !== 'MainContent') return;
    var target = document.getElementById(hash);
    if (!target) return;
    e.preventDefault();
    scrollToId(hash, hash === 'waitlist');
  }

  document.addEventListener('click', onAnchorClick);

  document.querySelectorAll('[data-scroll-to]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (el.hasAttribute('data-open-waitlist')) return;
      var id = el.getAttribute('data-scroll-to');
      if (!id || id === 'waitlist') return;
      if (!document.getElementById(id)) return;
      e.preventDefault();
      scrollToId(id, false);
    });
  });


  document.querySelectorAll('[data-prefill-plan]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var plan = btn.getAttribute('data-prefill-plan');
      var radio = document.querySelector('input[name="waitlist_plan"][value="' + plan + '"]');
      if (radio) {
        radio.checked = true;
        syncWaitlistMeta();
      }
      var modalRadio = document.querySelector('input[name="waitlist_plan_modal"][value="' + plan + '"]');
      if (modalRadio) modalRadio.checked = true;
      /* Prefill only — data-open-waitlist handled by inline script in theme.liquid */
      if (btn.hasAttribute('data-open-waitlist')) {
        return;
      }
      var hash = hashFromHref(btn.getAttribute('href')) || 'waitlist';
      if (document.getElementById(hash)) {
        e.preventDefault();
        scrollToId(hash, true);
      }
    });
  });

  function handleInitialHash() {
    var hash = (location.hash || '').replace(/^#/, '');
    if (!hash) return;
    if (document.getElementById(hash)) {
      // Delay slightly for layout / sticky header
      setTimeout(function () {
        scrollToId(hash, hash === 'waitlist');
      }, 60);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialHash);
  } else {
    handleInitialHash();
  }

  /* —— Fairy story modal —— */
  var overlay = document.getElementById('fairy-modal-overlay');
  var modal = document.getElementById('fairy-modal');
  var modalBody = document.getElementById('fairy-modal-body');
  var modalClose = document.getElementById('fairy-modal-close');
  var lastFocus = null;
  var trapHandler = null;


  function ensureFairiesData(done) {
    if (window.FAIRIES_DATA && window.FAIRIES_DATA.length) {
      done();
      return;
    }
    if (!window.__fwfFairiesQ) window.__fwfFairiesQ = [];
    window.__fwfFairiesQ.push(done);
    if (window.__fwfFairiesLoading) return;
    var url = window.FWF_FAIRIES_DATA_URL;
    if (!url) {
      window.__fwfFairiesQ = [];
      done();
      return;
    }
    window.__fwfFairiesLoading = true;
    var s = document.createElement('script');
    s.src = url;
    s.async = true;
    s.onload = function () {
      window.__fwfFairiesLoading = false;
      var q = window.__fwfFairiesQ || [];
      window.__fwfFairiesQ = [];
      for (var i = 0; i < q.length; i++) q[i]();
    };
    s.onerror = function () {
      window.__fwfFairiesLoading = false;
      window.__fwfFairiesQ = [];
    };
    document.head.appendChild(s);
  }

  function fairyById(id) {
    var list = window.FAIRIES_DATA || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
    }
    return null;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getFocusable(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.hasAttribute('disabled') && el.offsetParent !== null;
    });
  }

  function openFairyModal(id, triggerEl) {
    ensureFairiesData(function () {
      openFairyModalReady(id, triggerEl);
    });
  }

  function openFairyModalReady(id, triggerEl) {
    var fairy = fairyById(id);
    if (!fairy || !overlay || !modalBody) return;

    var card = triggerEl || document.querySelector('[data-fairy-id="' + id + '"]');
    var imgEl = card && card.querySelector('img');
    var imgSrc = imgEl ? imgEl.getAttribute('src') : '';
    var imgAlt = imgEl ? imgEl.getAttribute('alt') : fairy.name;

    lastFocus = document.activeElement;

    var storyHtml = fairy.story
      .map(function (p) { return '<p>' + escapeHtml(p) + '</p>'; })
      .join('');

    modalBody.innerHTML =
      '<div class="fairy-modal-content">' +
        '<div class="fairy-modal-image">' +
          '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(imgAlt || fairy.name) + '" width="480" height="600"/>' +
        '</div>' +
        '<div class="fairy-modal-copy">' +
          '<span class="gift-badge">' + escapeHtml(fairy.gift) + '</span>' +
          '<h2 id="fairy-modal-title">' + escapeHtml(fairy.name) + '</h2>' +
          '<p class="fairy-modal-tagline">' + escapeHtml(fairy.tagline) + '</p>' +
          '<div class="fairy-modal-story">' + storyHtml + '</div>' +
          '<div class="fairy-modal-footer">' +
            '<p class="fairy-modal-may">May appear in a future subscription</p>' +
            '<a href="/#circle" class="btn btn-primary btn-sm" data-join-cta data-cta-location="fairy-modal" data-modal-waitlist>Join free waitlist</a>' +
          '</div>' +
        '</div>' +
      '</div>';

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    if (modalClose) modalClose.focus();

    var waitLink = modalBody.querySelector('[data-modal-waitlist]');
    if (waitLink) {
      waitLink.addEventListener('click', function () {
        closeFairyModal();
        /* link scrolls to #circle (plans) via onAnchorClick */
      });
    }

    trapHandler = function (e) {
      if (e.key !== 'Tab' || !overlay.classList.contains('is-open')) return;
      var focusable = getFocusable(modal);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', trapHandler);
  }

  function closeFairyModal() {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (trapHandler) {
      document.removeEventListener('keydown', trapHandler);
      trapHandler = null;
    }
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  document.querySelectorAll('[data-fairy-id]').forEach(function (card) {
    card.addEventListener('click', function () {
      openFairyModal(card.getAttribute('data-fairy-id'), card);
    });
  });

  if (modalClose) {
    modalClose.addEventListener('click', closeFairyModal);
  }
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeFairyModal();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) {
      closeFairyModal();
    }
  });

  /* —— Fairy category filters —— */
  (function initFairyFilters() {
    var chips = document.getElementById('filter-chips');
    var grid = document.getElementById('fairy-grid');
    if (!chips || !grid) return;

    function applyFilter(filter) {
      grid.querySelectorAll('.fairy-grid-item').forEach(function (item) {
        var cat = item.getAttribute('data-category') || '';
        var show = filter === 'all' || cat === filter;
        item.classList.toggle('is-hidden', !show);
      });
    }

    chips.addEventListener('click', function (e) {
      var chip = e.target.closest('.filter-chip');
      if (!chip) return;
      var filter = chip.getAttribute('data-filter') || 'all';
      chips.querySelectorAll('.filter-chip').forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyFilter(filter);
    });

    // Apply the chip marked active in HTML on first paint (e.g. Motherhood default)
    var initial = chips.querySelector('.filter-chip.is-active');
    applyFilter(initial ? (initial.getAttribute('data-filter') || 'all') : 'all');
  })();

})();
